import { render, staticRenderFns } from "./ProductDetailsTopCard.vue?vue&type=template&id=7b957ef2&scoped=true"
import script from "./ProductDetailsTopCard.vue?vue&type=script&lang=js"
export * from "./ProductDetailsTopCard.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsTopCard.vue?vue&type=style&index=0&id=7b957ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b957ef2",
  null
  
)

export default component.exports